module.exports = __webpack_public_path__ + "assets/4791095d9999740511711cecff97049c.svg";